import { advisorState } from './advisor.state';
import { advisorActions } from './advisor.action';
import { advisorMutations } from './advisor.mutation';

export default {
  namespaced: true,
  state: advisorState,
  getters: {},
  actions: advisorActions,
  mutations: advisorMutations,
};
